import Image from 'next/image';
import NextLink from 'next/link';
import { Box, Text, RichText, Inline, Button } from '@stitch-fix/mode-react';
import fullBodyPlaceholder from '../../../../public/Onboarding_Full_Body_Placeholder.svg';
import styles from './MissingFullBodyCta.module.scss';
const profilePhotosHref = '/profile/photos?scrollTo=fullBody';
const MissingFullBodyCta = () => {
  return <NextLink href={profilePhotosHref} className={styles.link} data-testid="missing-full-body-cta">
      <Box bgColor="gray-95" className={styles.cta}>
        <Inline vAlign="center" spacing={0.75}>
          <Box aria-hidden="true" className={styles.iconContainer}>
            <Image alt="" src={fullBodyPlaceholder} width={18} height={34} />
          </Box>
          <Box className={styles.copy}>
            <Text setting="body-small" color="blue-45" align="left">
              <RichText>
                Make it more like you - Add a *full-body* photo.
              </RichText>
            </Text>
          </Box>
        </Inline>
        <Button as="span" variant="text" aria-hidden="true">
          Add photo
        </Button>
      </Box>
    </NextLink>;
};
export default MissingFullBodyCta;